const serializeIdentifier = (identifier?: string): string => {
  return identifier?.length && identifier !== '/' && identifier !== 'undefined'
    ? identifier
    : '';
};

export default serializeIdentifier;
